import React from "react";
import { Divider, Flex, Image } from "antd";
import logo1 from "../../../images/20241101_161042.jpg";
import logo2 from "../../../images/Рисунок22.jpg";
import logo3 from "../../../images/Рисунок23.png";
import logo4 from "../../../images/Logo-FAV-gGmbH.jpg";

const Footer = () => {
  return (
    <Flex
      vertical
      align="center"
      style={{
        width: "100%",
        padding: "30px 15px 20px",
        zIndex: 10,
        overflow: "hidden",
      }}
    >
      <Flex
        wrap
        justify="center"
        align="center"
        gap={40}
        style={{
          width: "100%",
          maxWidth: 1440,
          paddingBottom: 20,
        }}
      >
        <Image width={180} src={logo1} preview={false} />
        <Image width={130} src={logo2} preview={false} />
        <Image width={220} src={logo3} preview={false} />
        <Image width={100} src={logo4} preview={false} />
      </Flex>
      <Divider />

      <div
        style={{
          fontSize: 12,
          color: "#999",
          marginTop: 10,
          textAlign: "center",
        }}
      >
        © {new Date().getFullYear()} Хөгжил мэргэжлийн чиг баримжаа боловсрол
        олгох төв. Бүх эрх хуулиар хамгаалагдсан.
      </div>
    </Flex>
  );
};

export default Footer;
